import { ExternalInfos } from '@/domain/external/entities/external.entity';
import { createAppAsyncThunk } from '@/domain/store.thunk';

type Result = ExternalInfos;

export const getExternalInfos = createAppAsyncThunk(
  'external/getExternalInfos',
  async (code: string, { extra: { externalGateway } }): Promise<Result> => {
    return await externalGateway.getExternalInfos(code);
  },
);
